import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createMockProduct, createProductsAndExchangeToProductsFn } from "../mockCore";

function getImagePropertyValue(propertyValue) {
    return propertyValue.replace("/", "_");
}

function getSmallImage(propertyValue) {
    return `/mocks/Rapunzel-${getImagePropertyValue(propertyValue)}-small.webp`;
}

function getImages(propertyValue) {
    return [`/mocks/Rapunzel-${getImagePropertyValue(propertyValue)}.webp`, `/mocks/Rapunzel-after.jpg`, `/mocks/Rapunzel-before.webp`, `/mocks/Rapunzel-after-back.jpg`, getSmallImage(propertyValue)];
}

function localCreateProductVariant({ propertyValue, propertyName, variantDescription, propertyDescription, displayPriority, inventoryMerchant = 1 }) {
    return {
        description: variantDescription,
        imageSrcs: getImages(propertyValue),
        inventoryTurnr: 0,
        inventoryMerchant,
        properties: [
            {
                type: "Color",
                value: propertyValue,
                nameShort: propertyValue,
                name: propertyName,
                imageSrc: getSmallImage(propertyValue),
                description: propertyDescription,
                displayPriority,
            },
        ],
    };
}

const productData1 = {
    product: createMockProduct({
        id: 1,
        productNameShort: "B5.0/8.3",
        productName: "Classic Clip-ins",
        imageSrcs: getImages("B5.0_8.3"),
        purchasePrice: 499,
        properties: [
            {
                type: "Color",
                value: "B5.0/8.3",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            localCreateProductVariant({
                propertyValue: "1.0",
                propertyName: "Black",
                propertyDescription: "Svart. Solid färg. Neutral ton.",
                displayPriority: 1,
            }),
            localCreateProductVariant({
                propertyValue: "10.7",
                propertyName: "Light Grey",
                propertyDescription: "Ljusblond. Grå underton. Solid färg. Kall ton.",
                displayPriority: 2,
            }),
            localCreateProductVariant({
                propertyValue: "B2.3/5.0",
                propertyName: "Brownish Blonde Balayage",
                propertyDescription: "Mörkbrun bas. Övergår i ljusa och mörka brunblonda slingor. Balayage. Varmkall ton.",
                displayPriority: 3,
            }),
            localCreateProductVariant({
                propertyValue: "B5.0/8.3",
                propertyName: "Brownish Blonde Balayage",
                propertyDescription: "Guldbrun bas. Övergår i varma, brunblonda slingor. Balayage. Varm ton.",
                displayPriority: 4,
                inventoryMerchant: 0,
            }),
        ],
    },
    similarProducts: [],
};

const productData2Variants = [
    localCreateProductVariant({
        propertyValue: "1.0",
        propertyName: "Black",
        propertyDescription: "Black. Solid colour. Neutral tone.",
        displayPriority: 1,
        inventoryMerchant: 0,
    }),
    localCreateProductVariant({
        propertyValue: "1.2",
        propertyName: "Black Brown",
        propertyDescription: "Brown-black. Solid colour. Neutral tone.",
        displayPriority: 2,
    }),
    localCreateProductVariant({
        propertyValue: "2.0",
        propertyName: "Dark Brown",
        propertyDescription: "Dark brown. Slightly red undertone. Solid colour. Warm tone.",
        displayPriority: 3,
    }),
    localCreateProductVariant({
        propertyValue: "2.3",
        propertyName: "Chocolate Brown",
        propertyDescription: "Dark brown. Solid colour. Warm tone.",
        displayPriority: 4,
    }),
    localCreateProductVariant({
        propertyValue: "10.7",
        propertyName: "Light Grey",
        propertyDescription: "Light blonde. Grey undertone. Solid colour. Cool tone.",
        displayPriority: 5,
    }),
    localCreateProductVariant({
        propertyValue: "10.10",
        propertyName: "Platinum Blonde",
        propertyDescription: "Very light blonde. Solid colour. Cool undertone.",
        displayPriority: 6,
    }),
    localCreateProductVariant({
        propertyValue: "B2.3/5.0",
        propertyName: "Hazelnut Caramel Balayage",
        propertyDescription: "Dark brown base. Transitions to light and dark bronde highlights. Balayage. Warm/cool tone.",
        displayPriority: 7,
        inventoryMerchant: 0,
    }),
    localCreateProductVariant({
        propertyValue: "B2.6/10.7",
        propertyName: "Dark Ashy Blonde Balayage",
        propertyDescription: "Ash brown base. Transitions to light and dark, cool highlights. Balayage. Cool tone.",
        displayPriority: 8,
    }),
    localCreateProductVariant({
        propertyValue: "B5.0/8.3",
        propertyName: "Brownish Blonde Balayage",
        propertyDescription: "Golden brown base. Transitions to warm brown-blond highlights. Balayage. Warm tone.",
        displayPriority: 9,
    }),
    localCreateProductVariant({
        propertyValue: "M7.3/10.8",
        propertyName: "Brownish Blonde Balayage",
        propertyDescription: "Light, cendre ash and light blonde. Mix. Cool tone.",
        displayPriority: 10,
    }),
];

const productData2 = {
    product: createMockProduct({
        id: 2,
        productNameShort: "1.0",
        productName: "Classic Clip-ins",
        imageSrcs: getImages("1.0"),
        purchasePrice: 499,
        properties: [
            {
                type: "Color",
                value: "1.0",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: productData2Variants,
    },
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        productNameShort: "6.0",
        productName: "Classic Clip-ins",
        imageSrcs: getImages("6.0"),
        purchasePrice: 499,
        properties: [
            {
                type: "Color",
                value: "6.0",
            },
        ],
    }),
    exchangeToProductsData: {
        originalProductVariants: productData2Variants?.concat(
            localCreateProductVariant({
                propertyValue: "6.0",
                propertyName: "Red Fire",
                propertyDescription: "Intense red. Solid colour.",
                displayPriority: 4.5,
                inventoryMerchant: 0,
            }),
        ),
    },
};

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
            {
                type: SHIPMENT_SOLUTION_TYPES.RETURN_IN_STORE.key,
                cost: 0,
            },
            // {
            //     // carrier: SHIPMENT_CARRIERS.BUDBEE,
            //     type: SHIPMENT_SOLUTION_TYPES.MANUAL.key,
            //     cost: 39,
            // },
            // {
            //     // carrier: SHIPMENT_CARRIERS.BUDBEE,
            //     type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL_MANUAL_UPLOAD.key,
            //     cost: 39,
            // },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        orderCreatedAt: "2024-06-12T14:29:13.218779489Z",
        remainingReturnDays: 28,
        remainingWithdrawalDays: 14,
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}

export function getSimilarProducts({ productId }) {
    return productsAndExchangeToProductsFn.similarProductsFn({ productId });
}
